import { createFileRoute } from '@tanstack/react-router';
import NotFound from '@/components/layout/not-found.tsx';
import { t } from '@/lib/i18n';

export const Route = createFileRoute('/not-found')({
	component: NotFound,
	head: () => ({
		meta: [
			{
				name: 'apple-mobile-web-app-title',
				content: `Jervice - ${t('global.not_found.title')}`,
			},
			{
				name: 'og:title',
				content: `Jervice - ${t('global.not_found.title')}`,
			},
			{
				name: 'og:description',
				content: t('global.not_found.description'),
			},
			{
				name: 'og:image',
				content: `/images/main.png`,
			},

			{
				name: 'twitter:title',
				content: `Jervice - ${'global.not_found.title'}`,
			},
			{
				name: 'twitter:description',
				content: t('global.not_found.description'),
			},
			{
				name: 'twitter:image',
				content: `/images/main.png`,
			},

			{ title: `Jervice - ${t('global.not_found.title')}` },
		],
	}),
});
